module.exports = __webpack_public_path__ + "static/media/logowhite.5d571650.svg";